'use client';

import { useEffect } from 'react';

import { useDecisions } from '@libs/common-next';

import { useProduct } from '@/entities/product';
import { getCustomerFrequencySelection, getValues, setValue } from '@/entities/purchase-form';
import { resolveAutoshipFrequencySelection } from '@/features/select-frequency/mapRecommendedAutoshipFrequency';

export const useApplyRecommendedAutoshipFrequency = () => {
    const isEnabled = useDecisions('dyn_as_freq');
    const as_freq_5_7 = useDecisions('as_freq_5_7');
    const { product } = useProduct();
    const sku = product?.sku;
    const recommendedFrequency = product?.recommendedAutoshipFrequency;
    const recommendedUnit = product?.recommendedAutoshipFrequencyUnitOfMeasure;

    useEffect(() => {
        if (!isEnabled || !sku) return;

        const nextSelection = resolveAutoshipFrequencySelection({
            isEnabled,
            customerSelection: getCustomerFrequencySelection(sku),
            recommendedFrequency,
            recommendedUnit,
            as_freq_5_7,
        });

        if (
            getValues('autoshipFrequency') === nextSelection.autoshipFrequency &&
            getValues('autoshipUnit') === nextSelection.autoshipUnit
        ) {
            return;
        }

        setValue('autoshipFrequency', nextSelection.autoshipFrequency);
        setValue('autoshipUnit', nextSelection.autoshipUnit);
    }, [as_freq_5_7, isEnabled, recommendedFrequency, recommendedUnit, sku]);
};
